// Minecraft Skin UV Mapping
// Skin texture is 64x64 pixels (or 64x32 for legacy)
// This file defines the pixel regions for each body part

import { BodyPart, Layer, BodyPartRegion } from './types';

// All body part regions in the 64x64 skin texture
export const SKIN_REGIONS: BodyPartRegion[] = [
  // HEAD - Base Layer
  { name: 'Head Top', part: 'head', layer: 'base', x: 8, y: 0, width: 8, height: 8 },
  { name: 'Head Bottom', part: 'head', layer: 'base', x: 16, y: 0, width: 8, height: 8 },
  { name: 'Head Right', part: 'head', layer: 'base', x: 0, y: 8, width: 8, height: 8 },
  { name: 'Head Front', part: 'head', layer: 'base', x: 8, y: 8, width: 8, height: 8 },
  { name: 'Head Left', part: 'head', layer: 'base', x: 16, y: 8, width: 8, height: 8 },
  { name: 'Head Back', part: 'head', layer: 'base', x: 24, y: 8, width: 8, height: 8 },

  // HEAD - Overlay Layer
  { name: 'Head Top (Overlay)', part: 'head', layer: 'overlay', x: 40, y: 0, width: 8, height: 8 },
  { name: 'Head Bottom (Overlay)', part: 'head', layer: 'overlay', x: 48, y: 0, width: 8, height: 8 },
  { name: 'Head Right (Overlay)', part: 'head', layer: 'overlay', x: 32, y: 8, width: 8, height: 8 },
  { name: 'Head Front (Overlay)', part: 'head', layer: 'overlay', x: 40, y: 8, width: 8, height: 8 },
  { name: 'Head Left (Overlay)', part: 'head', layer: 'overlay', x: 48, y: 8, width: 8, height: 8 },
  { name: 'Head Back (Overlay)', part: 'head', layer: 'overlay', x: 56, y: 8, width: 8, height: 8 },

  // BODY - Base Layer
  { name: 'Body Top', part: 'body', layer: 'base', x: 20, y: 16, width: 8, height: 4 },
  { name: 'Body Bottom', part: 'body', layer: 'base', x: 28, y: 16, width: 8, height: 4 },
  { name: 'Body Right', part: 'body', layer: 'base', x: 16, y: 20, width: 4, height: 12 },
  { name: 'Body Front', part: 'body', layer: 'base', x: 20, y: 20, width: 8, height: 12 },
  { name: 'Body Left', part: 'body', layer: 'base', x: 28, y: 20, width: 4, height: 12 },
  { name: 'Body Back', part: 'body', layer: 'base', x: 32, y: 20, width: 8, height: 12 },

  // BODY - Overlay Layer
  { name: 'Body Top (Overlay)', part: 'body', layer: 'overlay', x: 20, y: 32, width: 8, height: 4 },
  { name: 'Body Bottom (Overlay)', part: 'body', layer: 'overlay', x: 28, y: 32, width: 8, height: 4 },
  { name: 'Body Right (Overlay)', part: 'body', layer: 'overlay', x: 16, y: 36, width: 4, height: 12 },
  { name: 'Body Front (Overlay)', part: 'body', layer: 'overlay', x: 20, y: 36, width: 8, height: 12 },
  { name: 'Body Left (Overlay)', part: 'body', layer: 'overlay', x: 28, y: 36, width: 4, height: 12 },
  { name: 'Body Back (Overlay)', part: 'body', layer: 'overlay', x: 32, y: 36, width: 8, height: 12 },

  // RIGHT ARM - Base Layer (Classic: 4px wide, Slim: 3px wide)
  { name: 'Right Arm Top', part: 'rightArm', layer: 'base', x: 44, y: 16, width: 4, height: 4 },
  { name: 'Right Arm Bottom', part: 'rightArm', layer: 'base', x: 48, y: 16, width: 4, height: 4 },
  { name: 'Right Arm Right', part: 'rightArm', layer: 'base', x: 40, y: 20, width: 4, height: 12 },
  { name: 'Right Arm Front', part: 'rightArm', layer: 'base', x: 44, y: 20, width: 4, height: 12 },
  { name: 'Right Arm Left', part: 'rightArm', layer: 'base', x: 48, y: 20, width: 4, height: 12 },
  { name: 'Right Arm Back', part: 'rightArm', layer: 'base', x: 52, y: 20, width: 4, height: 12 },

  // RIGHT ARM - Overlay Layer
  { name: 'Right Arm Top (Overlay)', part: 'rightArm', layer: 'overlay', x: 44, y: 32, width: 4, height: 4 },
  { name: 'Right Arm Bottom (Overlay)', part: 'rightArm', layer: 'overlay', x: 48, y: 32, width: 4, height: 4 },
  { name: 'Right Arm Right (Overlay)', part: 'rightArm', layer: 'overlay', x: 40, y: 36, width: 4, height: 12 },
  { name: 'Right Arm Front (Overlay)', part: 'rightArm', layer: 'overlay', x: 44, y: 36, width: 4, height: 12 },
  { name: 'Right Arm Left (Overlay)', part: 'rightArm', layer: 'overlay', x: 48, y: 36, width: 4, height: 12 },
  { name: 'Right Arm Back (Overlay)', part: 'rightArm', layer: 'overlay', x: 52, y: 36, width: 4, height: 12 },

  // LEFT ARM - Base Layer
  { name: 'Left Arm Top', part: 'leftArm', layer: 'base', x: 36, y: 48, width: 4, height: 4 },
  { name: 'Left Arm Bottom', part: 'leftArm', layer: 'base', x: 40, y: 48, width: 4, height: 4 },
  { name: 'Left Arm Right', part: 'leftArm', layer: 'base', x: 32, y: 52, width: 4, height: 12 },
  { name: 'Left Arm Front', part: 'leftArm', layer: 'base', x: 36, y: 52, width: 4, height: 12 },
  { name: 'Left Arm Left', part: 'leftArm', layer: 'base', x: 40, y: 52, width: 4, height: 12 },
  { name: 'Left Arm Back', part: 'leftArm', layer: 'base', x: 44, y: 52, width: 4, height: 12 },

  // LEFT ARM - Overlay Layer
  { name: 'Left Arm Top (Overlay)', part: 'leftArm', layer: 'overlay', x: 52, y: 48, width: 4, height: 4 },
  { name: 'Left Arm Bottom (Overlay)', part: 'leftArm', layer: 'overlay', x: 56, y: 48, width: 4, height: 4 },
  { name: 'Left Arm Right (Overlay)', part: 'leftArm', layer: 'overlay', x: 48, y: 52, width: 4, height: 12 },
  { name: 'Left Arm Front (Overlay)', part: 'leftArm', layer: 'overlay', x: 52, y: 52, width: 4, height: 12 },
  { name: 'Left Arm Left (Overlay)', part: 'leftArm', layer: 'overlay', x: 56, y: 52, width: 4, height: 12 },
  { name: 'Left Arm Back (Overlay)', part: 'leftArm', layer: 'overlay', x: 60, y: 52, width: 4, height: 12 },

  // RIGHT LEG - Base Layer
  { name: 'Right Leg Top', part: 'rightLeg', layer: 'base', x: 4, y: 16, width: 4, height: 4 },
  { name: 'Right Leg Bottom', part: 'rightLeg', layer: 'base', x: 8, y: 16, width: 4, height: 4 },
  { name: 'Right Leg Right', part: 'rightLeg', layer: 'base', x: 0, y: 20, width: 4, height: 12 },
  { name: 'Right Leg Front', part: 'rightLeg', layer: 'base', x: 4, y: 20, width: 4, height: 12 },
  { name: 'Right Leg Left', part: 'rightLeg', layer: 'base', x: 8, y: 20, width: 4, height: 12 },
  { name: 'Right Leg Back', part: 'rightLeg', layer: 'base', x: 12, y: 20, width: 4, height: 12 },

  // RIGHT LEG - Overlay Layer
  { name: 'Right Leg Top (Overlay)', part: 'rightLeg', layer: 'overlay', x: 4, y: 32, width: 4, height: 4 },
  { name: 'Right Leg Bottom (Overlay)', part: 'rightLeg', layer: 'overlay', x: 8, y: 32, width: 4, height: 4 },
  { name: 'Right Leg Right (Overlay)', part: 'rightLeg', layer: 'overlay', x: 0, y: 36, width: 4, height: 12 },
  { name: 'Right Leg Front (Overlay)', part: 'rightLeg', layer: 'overlay', x: 4, y: 36, width: 4, height: 12 },
  { name: 'Right Leg Left (Overlay)', part: 'rightLeg', layer: 'overlay', x: 8, y: 36, width: 4, height: 12 },
  { name: 'Right Leg Back (Overlay)', part: 'rightLeg', layer: 'overlay', x: 12, y: 36, width: 4, height: 12 },

  // LEFT LEG - Base Layer
  { name: 'Left Leg Top', part: 'leftLeg', layer: 'base', x: 20, y: 48, width: 4, height: 4 },
  { name: 'Left Leg Bottom', part: 'leftLeg', layer: 'base', x: 24, y: 48, width: 4, height: 4 },
  { name: 'Left Leg Right', part: 'leftLeg', layer: 'base', x: 16, y: 52, width: 4, height: 12 },
  { name: 'Left Leg Front', part: 'leftLeg', layer: 'base', x: 20, y: 52, width: 4, height: 12 },
  { name: 'Left Leg Left', part: 'leftLeg', layer: 'base', x: 24, y: 52, width: 4, height: 12 },
  { name: 'Left Leg Back', part: 'leftLeg', layer: 'base', x: 28, y: 52, width: 4, height: 12 },

  // LEFT LEG - Overlay Layer
  { name: 'Left Leg Top (Overlay)', part: 'leftLeg', layer: 'overlay', x: 4, y: 48, width: 4, height: 4 },
  { name: 'Left Leg Bottom (Overlay)', part: 'leftLeg', layer: 'overlay', x: 8, y: 48, width: 4, height: 4 },
  { name: 'Left Leg Right (Overlay)', part: 'leftLeg', layer: 'overlay', x: 0, y: 52, width: 4, height: 12 },
  { name: 'Left Leg Front (Overlay)', part: 'leftLeg', layer: 'overlay', x: 4, y: 52, width: 4, height: 12 },
  { name: 'Left Leg Left (Overlay)', part: 'leftLeg', layer: 'overlay', x: 8, y: 52, width: 4, height: 12 },
  { name: 'Left Leg Back (Overlay)', part: 'leftLeg', layer: 'overlay', x: 12, y: 52, width: 4, height: 12 },
];

// Get all regions for a specific body part
export function getRegionsForPart(part: BodyPart, layer?: Layer): BodyPartRegion[] {
  return SKIN_REGIONS.filter(
    region => region.part === part && (layer === undefined || region.layer === layer)
  );
}

// Get the region at a specific pixel coordinate
export function getRegionAtPixel(x: number, y: number): BodyPartRegion | null {
  for (const region of SKIN_REGIONS) {
    if (
      x >= region.x &&
      x < region.x + region.width &&
      y >= region.y &&
      y < region.y + region.height
    ) {
      return region;
    }
  }
  return null;
}

// Check if a pixel is within any defined body part region
export function isPixelInSkinArea(x: number, y: number): boolean {
  return getRegionAtPixel(x, y) !== null;
}

// ---------------------------------------------------------------------------------------------
// MODEL-AWARE face map.
//
// `SKIN_REGIONS` above is the CLASSIC (4px arm) layout only. The slim model's arm faces are laid
// out differently (front/back/top/bottom are 3px wide and everything after the front shifts one
// column left), so anything that has to know "which face is this pixel on" — the mirror, fill
// bounds, brush clipping, the Body Parts view — goes through `getFaceRegions(modelType)`.
// The rectangles are derived the way Mojang's box unwrap does it (see `boxFaces`), and they match
// `app/lib/3d/geometry/MinecraftPlayerGeometry.ts` face for face.
// ---------------------------------------------------------------------------------------------

export type SkinModel = 'classic' | 'slim';
export type FaceName = 'top' | 'bottom' | 'right' | 'front' | 'left' | 'back';

export interface FaceRegion {
  part: BodyPart;
  layer: Layer;
  face: FaceName;
  x: number;
  y: number;
  width: number;
  height: number;
}

/**
 * Minecraft's box unwrap for a box of width w (x), height h (y), depth d (z) whose texture origin is
 * (u, v): row 1 = [top][bottom], row 2 = [right][front][left][back]. "right" is the CHARACTER's
 * right (the viewer's left when looking at the front).
 */
function boxFaces(part: BodyPart, layer: Layer, u: number, v: number, w: number, h: number, d: number): FaceRegion[] {
  return [
    { part, layer, face: 'top', x: u + d, y: v, width: w, height: d },
    { part, layer, face: 'bottom', x: u + d + w, y: v, width: w, height: d },
    { part, layer, face: 'right', x: u, y: v + d, width: d, height: h },
    { part, layer, face: 'front', x: u + d, y: v + d, width: w, height: h },
    { part, layer, face: 'left', x: u + d + w, y: v + d, width: d, height: h },
    { part, layer, face: 'back', x: u + 2 * d + w, y: v + d, width: w, height: h },
  ];
}

// Texture origin (u, v) of each part's box, per UV layer.
const BOX_ORIGINS: Record<BodyPart, Record<Layer, [number, number]>> = {
  head: { base: [0, 0], overlay: [32, 0] },
  body: { base: [16, 16], overlay: [16, 32] },
  rightArm: { base: [40, 16], overlay: [40, 32] },
  leftArm: { base: [32, 48], overlay: [48, 48] },
  rightLeg: { base: [0, 16], overlay: [0, 32] },
  leftLeg: { base: [16, 48], overlay: [0, 48] },
};

function buildFaceRegions(model: SkinModel): FaceRegion[] {
  const out: FaceRegion[] = [];
  const parts: BodyPart[] = ['head', 'body', 'rightArm', 'leftArm', 'rightLeg', 'leftLeg'];
  for (const part of parts) {
    const [w, h, d] =
      part === 'head' ? [8, 8, 8]
      : part === 'body' ? [8, 12, 4]
      : (part === 'rightArm' || part === 'leftArm') && model === 'slim' ? [3, 12, 4]
      : [4, 12, 4];
    for (const layer of ['base', 'overlay'] as const) {
      const [u, v] = BOX_ORIGINS[part][layer];
      out.push(...boxFaces(part, layer, u, v, w, h, d));
    }
  }
  return out;
}

const FACE_REGIONS: Record<SkinModel, FaceRegion[]> = {
  classic: buildFaceRegions('classic'),
  slim: buildFaceRegions('slim'),
};

// Per-pixel lookup table (64x64) per model, so the brush/mirror hot path is O(1).
function buildFaceIndex(regions: FaceRegion[]): Int16Array {
  const idx = new Int16Array(64 * 64).fill(-1);
  regions.forEach((r, i) => {
    for (let y = r.y; y < r.y + r.height; y++) {
      for (let x = r.x; x < r.x + r.width; x++) idx[y * 64 + x] = i;
    }
  });
  return idx;
}
const FACE_INDEX: Record<SkinModel, Int16Array> = {
  classic: buildFaceIndex(FACE_REGIONS.classic),
  slim: buildFaceIndex(FACE_REGIONS.slim),
};

/** Every face rectangle of the 64x64 sheet for this model (72 = 6 parts x 2 layers x 6 faces). */
export function getFaceRegions(model: SkinModel): readonly FaceRegion[] {
  return FACE_REGIONS[model];
}

/** The face a texture pixel belongs to for this model, or null for the unused parts of the sheet. */
export function getFaceAtPixel(x: number, y: number, model: SkinModel): FaceRegion | null {
  if (x < 0 || x >= 64 || y < 0 || y >= 64) return null;
  const i = FACE_INDEX[model][y * 64 + x];
  return i < 0 ? null : FACE_REGIONS[model][i];
}

const MIRROR_PART: Record<BodyPart, BodyPart> = {
  head: 'head',
  body: 'body',
  rightArm: 'leftArm',
  leftArm: 'rightArm',
  rightLeg: 'leftLeg',
  leftLeg: 'rightLeg',
};
const MIRROR_FACE: Record<FaceName, FaceName> = {
  top: 'top', bottom: 'bottom', front: 'front', back: 'back', right: 'left', left: 'right',
};

/**
 * Where a pixel lands when the character is mirrored across its centre plane (left <-> right).
 *
 * - Arms and legs swap with the opposite limb; head and body mirror onto THEMSELVES.
 * - The RIGHT face swaps with the LEFT face. (The old implementation matched faces by name and sent
 *   the right arm's outer side to the left arm's INNER side.)
 * - Every face flips horizontally: on top/bottom/front/back the horizontal axis IS the character's
 *   left-right axis, and on the side faces the flip keeps the front-adjacent column front-adjacent.
 * - Same UV layer (base <-> base, overlay <-> overlay).
 *
 * Mirroring twice returns the original pixel. Returns null outside every face. For head/body on an
 * even-width face no pixel maps to itself, so a stroke on the centre line paints both centre columns.
 */
export function getMirrorPixel(x: number, y: number, model: SkinModel): { x: number; y: number } | null {
  const face = getFaceAtPixel(x, y, model);
  if (!face) return null;
  const targetPart = MIRROR_PART[face.part];
  const targetFace = MIRROR_FACE[face.face];
  const target = FACE_REGIONS[model].find(r => r.part === targetPart && r.layer === face.layer && r.face === targetFace);
  if (!target || target.width !== face.width || target.height !== face.height) return null;
  const relX = x - face.x;
  const relY = y - face.y;
  return { x: target.x + (target.width - 1 - relX), y: target.y + relY };
}
